<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat>
      <q-card-section class="no-padding fixed-header-position">
        <q-banner class="bg-blue text-white" inline-actions>
          انتقال بین انبارها
          <template v-slot:avatar>
            <q-icon name="transfer_within_a_station"/>
          </template>
          <template v-slot:action>
            <q-btn icon="add" color="red" round @click="showGoodsTransferActions">
              <q-tooltip>
                افزودن سند جدید
              </q-tooltip>
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-toggle v-model="isDone" :true-value="1" :false-value="0"
                  :label="isDone===0?'اسناد تایید نشده':'اسناد تایید شده'"/>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-input v-model="filter" label="جستجو در لیست" filled />
      </q-card-section>
      <q-card-section>
        <q-table
            flat
            :hide-header="$q.screen.lt.md"
            :data="items"
            :filter="filter"
            :rows-per-page-options="[15]">
          <template v-slot:header>
            <q-tr class="text-center text-subtitle2">
              <td></td>
              <td>تاریخ درخواست</td>
              <td>شماره سند</td>
              <td>شرح انتقال</td>
              <td>درخواست کننده</td>
              <td>انبار مبدا</td>
              <td>انبار مقصد</td>
              <td>درصد پیشرفت</td>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <td style="width: 100px">
                <q-btn icon="check" padding="none" size="lg" round color="green" text-color="white"
                       @click="generateTransferRequestList(props.row)"
                       v-if="!props.row.IsDone && $store.state.roles.some(v=>['admin','can_accept_transfer'].includes(v))">
                  <q-tooltip>
                    تاییدیه نهایی انتقال
                  </q-tooltip>
                </q-btn>
                <q-btn icon="info" padding="none" size="lg" class="q-ml-xs" round color="indigo" text-color="white"
                       @click="showItemsDialog(props.row)">
                  <q-tooltip>
                    نمایش جزییات
                  </q-tooltip>
                </q-btn>
                <q-btn
                    icon="print" flat padding="none" size="lg" class="q-ml-xs" round color="indigo"
                    @click="printRequest(props.row)">
                  <q-tooltip>
                    چاپ
                  </q-tooltip>
                </q-btn>
                <q-btn
                    v-if="(!isDone && $store.state.roles.some(v=>['admin','can_accept_transfer'].includes(v)) ||
                    ($store.state.roles.some(v=>['admin','can_accept_transfer'].includes(v)))) && props.row.Progress===0"
                    icon="delete" flat padding="none" size="lg" class="q-ml-xs" round color="red-14"
                    @click="deleteRequest(props.row)">
                  <q-tooltip>
                    حذف درخواست انتقالی
                  </q-tooltip>
                </q-btn>
              </td>
              <td class="text-center" style="width: 100px">{{ props.row.RequesterDateTime | toJalaliDateTime }}</td>
              <td class="text-center text-subtitle1">
                {{ props.row.FriendlyName }}
              </td>
              <td style="width: 200px">
                {{ props.row.Reason }}
              </td>
              <td class="text-center">
                <q-chip icon="person" square :label="props.row.UserName"/>
              </td>
              <td class="text-center">
                <q-chip icon="store" square :label="props.row.SourceStoreName"/>
              </td>
              <td class="text-center">
                <q-chip icon="store" square :label="props.row.DestinationStoreName"/>
              </td>
              <td>
                <q-linear-progress size="25px" :value="props.row.Progress" color="teal">
                  <div class="absolute-full flex flex-center">
                    <q-badge color="white" text-color="teal" :label="`${props.row.Progress * 100}%`"/>
                  </div>
                </q-linear-progress>
              </td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-dialog maximized v-model="goodsTransferActionDialog">
      <GoodsTransferAction @transfer-request-added="transferRequestAdded"/>
    </q-dialog>
    <q-dialog maximized v-model="transferItemsDialog">
      <GoodsTransferItems @accept-transfer-request="acceptedTransferRequest" :is-dialog="true" :view-only="true"
                          :items="selectedTransferObject.GoodItems" :transfer-i-d="selectedTransferObject.transferId"
                          :is-done="isDone"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from "vuex";
import GoodsTransferAction from "@/components/store/GoodsTransferAction";
import GoodsTransferItems from "@/components/store/GoodsTransferItems";


export default {
  name: "GoodsTransfer",
  components: {GoodsTransferItems, GoodsTransferAction},
  data() {
    return {
      filter:'',
      isDone: 0,
      goodsTransferActionDialog: false,
      transferItemsDialog: false,
      items: [],
      selectedTransferObject: {
        transferId: null,
        GoodItems: []
      }
    }
  },
  methods: {
    ...mapActions({
      setList: 'Products/getGoodsTransferList',
      acceptTransferRequest: 'Products/acceptGoodsTransfer',
      generateTransferRequest: 'Products/generateGoodsTransferRequest',
      deleteFromList: 'Products/deleteGoodsTransfer'
    }),
    async printRequest(row) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/انتقالی?rs:Format=PDF&RequestID=${row.FriendlyName}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    generateTransferRequestList(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'درخواست انتقالی تایید گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        if (this.lodash.sumBy(row.GoodItems.map(item => item.acceptedCount)) !== 0) {
          this.generateTransferRequest(row.ID).then((res) => {
            this.items = this.items.filter(item => item.FriendlyName !== res[0].FriendlyName)
            this.$q.notify({
              type: 'positive',
              color: 'positive',
              position: 'top',
              message: `لیست درخواست انتقالی به شماره ${res[0].FriendlyName} برای انبارهای مبدا و مقصد ارسال گردید`
            })
          })
        } else {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position: 'top',
            message: `محصولی جهت انتقال تعیین نشده است`
          })
        }
      })
    },
    acceptedTransferRequest(args) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'درخواست انتقالی تایید گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.acceptTransferRequest({
          ID: this.selectedTransferObject.ID,
          items: args
        }).then((res) => {
          this.items = this.items.filter(item => item.ID !== res[0].ID)
          res[0].GoodItems = JSON.parse(res[0].GoodItems)
          this.items.push(res[0])
          this.transferItemsDialog = false
        })
      })
    },
    transferRequestAdded(item) {
      this.items.push(item)
      this.goodsTransferActionDialog = false
    },
    showItemsDialog(row) {
      if (typeof row.GoodItems === 'string') {
        row.GoodItems = JSON.parse(row.GoodItems);
      }
      this.selectedTransferObject = row;
      this.selectedTransferObject.transferId = row.ID;
      this.transferItemsDialog = true;
    },
    showGoodsTransferActions() {
      this.goodsTransferActionDialog = true;
    },
    deleteRequest(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'درخواست انتقالی حذف گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteFromList(row.ID).then(() => {
          this.items = this.items.filter(item => item.ID !== row.ID)
        })
      })
    },
    async loadData() {
      await this.setList(this.isDone).then((res) => {
        this.items = res
        this.items.forEach((record) => {
          record.GoodItems = eval(record.GoodItems)
        })
      })
    },
    refresh(done) {
      setTimeout(() => {
        this.loadData().then(() => {
          done()
        })
      }, 1000)
    },
  },
  watch: {
    isDone: function () {
      this.loadData()
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000
}
</style>